import { createSelector } from "reselect"
import { getAuthState } from "./getAuthState"

export const getUserErrors = createSelector(
  getAuthState,
  (authState) => authState.errors
)
